import { Controller } from "@hotwired/stimulus";
import LazyLoad from "vanilla-lazyload";

export default class extends Controller {
  connect() {
    this.lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy"
    });

    this.element.addEventListener("click", e => {
      const link = e.target.closest("a");
      const url = link.getAttribute("data-url");
      if (!url) return;
      e.preventDefault();
      e.stopPropagation();
      this.overlay.loadContent(url);
    });
  }

  get overlay() {
    return this.application.getControllerForElementAndIdentifier(
      document.body,
      "clients-overlay"
    );
  }
}
